import React from 'react';
import LinkWithQuery from './LinkWithQuery.tsx';

// eslint-disable-next-line react/prop-types
function AddProductButton({ length }) {
  return (
    <td
      colSpan={length !== 0 ? 4 : 8}
      // className="p-0 fw-bold pointer td-add pt-4 product-table"
      className="add-item"
    >
      <LinkWithQuery
        to="add-product"
        className="btn btn-light border border-primary w-100"
        data-testid="addItemButton"
      >
        {length === 0 ? 'Add item' : 'Add more items'}
      </LinkWithQuery>
    </td>
  );
}

export default AddProductButton;
